import { MobileAreaDataTypes } from '@/interface'
import { PaymentPlatform } from '@/interface/pay'
import { intlUrl } from '@/libs/config'
import request from '@/libs/functions/request'

export interface AiChatEntryResponse {
  enabled?: boolean
  iconUrl?: string
  [property: string]: any
}

export function getAiChatEntry() {
  return request<AiChatEntryResponse>({
    uri: '/api/business/member/chat/setting/entry',
    params: {},
    method: 'POST',
    options: {
      hasLoading: false,
      isShowMessage: false,
    },
  })
}

// 获取图片验证码
export function captchaImage(params = {}) {
  return request({
    uri: '/api/business/member/captcha/image',
    params,
    method: 'GET',
  })
}

// 发送短信
export function memberSendSms(params: {
  ticket: string
  capCode: string
  mobile: string
  tenantCode: string
  countryCallPrefix: string
}) {
  return request({
    uri: '/api/business/member/sendSms',
    params,
    method: 'POST',
  })
}

export function authSendSms(params: { mobile: string }) {
  return request({
    uri: '/api/business/member/tenant/auth/sendSms',
    params,
    method: 'POST',
  })
}

/**
 * 授权-核销类-获取短信验证码
 * @param params
 * @returns
 */
export function authSendSmsVerif(params: { mobile: string }) {
  return request({
    uri: '/api/business/coupon/tenant/auth/sendSms',
    params,
    method: 'POST',
  })
}

// 登录
export function login(params: {
  smsCode: string
  mobile: string
  tenantCode: string
  ip: string
  userAgent: string
  countryCallPrefix: string
  userName?: string
  urlParams?: {
    [key: string]: unknown
  }
  ticket: string
  capCode: string
}) {
  return request<Record<string, any>>({
    uri: '/api/business/member/login',
    params,
    method: 'POST',
  })
}

// 登录成功后校验
export function loginBind(params: {
  validateKey: string
  userName: string
  memberTag: string
  guestCode: string
  tenantCode: string
}) {
  return request<Record<string, any>>({
    uri: '/api/business/member/login/bind',
    params,
    method: 'POST',
  })
}

// 获取用户信息
export function memberInfo() {
  return request({
    uri: '/api/business/member/member/info',
    params: {},
    method: 'GET',
  })
}

// 获取权益类型列表
export function equityList() {
  return request({
    uri: '/api/business/member/equity/list',
    params: {},
    method: 'GET',
  })
}

// 获取权益详情
export function equityDetail(params?: any) {
  return request({
    uri: '/api/business/coupon/equity/detail',
    params,
    method: 'POST',
  })
}

// 获取权益类型列表内容
export function equityListCategory(params: {
  searchValid: boolean // 是否只显示有效权益
  category: string // 权益code
}) {
  return request({
    uri: '/api/business/member/equity/list/category',
    params,
    method: 'POST',
  })
}

// 消费记录列表
export function couponConsumeRecord(params?: any) {
  return request({
    uri: '/api/business/coupon/coupon/consume/record',
    params,
    method: 'POST',
  })
}

// 消费记录详情
export function consumeRecordDetail(params: { orderNo: string }) {
  return request({
    uri: '/api/business/coupon/coupon/consume/record',
    params,
    method: 'POST',
  })
}

// 凭证页
export function getQrcodeDetail(params?: any) {
  return request({
    uri: '/api/business/coupon/coupon/certificate/detail',
    params,
    method: 'POST',
  })
}

// 获取券码
export function getQrcode(params?: any) {
  return request({
    uri: '/api/business/coupon/coupon/certificate',
    params,
    method: 'POST',
  })
}

// 认证登录
export function getLoginStatus(params: {
  encryptionKey: string
  params: string
}) {
  return request({
    uri: '/api/business/coupon/auth/login',
    params,
    method: 'POST',
  })
}

// 绑定使用人
export function bindUserName(params: {
  useUserName: string // 使用人
}) {
  return request({
    uri: '/api/business/coupon/coupon/bind',
    params,
    method: 'POST',
  })
}

// 订单列表
export function orderPage(params: {
  current: number // 权益券码
  size: number // 类型
  orderStatus: string
}) {
  return request({
    uri: '/api/business/member/order/page',
    params,
    method: 'POST',
  })
}

// 订单详情
export function orderGet(params: { orderNo: string }) {
  return request({
    uri: '/api/business/member/order/get',
    params,
    method: 'POST',
  })
}

// 支付成功页配置
export function getPaySuccessPageConfig(params: { orderNo: string }) {
  return request({
    uri: '/api/business/member/pageDisplay/paySuccessPage/config',
    params,
    method: 'POST',
    options: {
      hasLoading: false,
    },
  })
}

// 刷新劵码
export function authRefresh(params: { equityCouponCode: string }) {
  return request({
    uri: '/api/business/coupon/auth/refresh',
    params,
    method: 'POST',
  })
}

// 确认绑定
export function equityConfirmBind(params: {
  equityCouponCode: string // 权益券码
}) {
  return request({
    uri: '/api/business/member/equity/confirmBind',
    params,
    method: 'POST',
  })
}

// 优惠券
export function couponListMyCoupon(params: {
  status: number // 状态 0待使用 1已使用 3已过期 4作废
}) {
  return request({
    uri: '/api/business/member/coupon/listMyCoupon',
    params,
    method: 'GET',
  })
}

// 获取支付列表
export function payList(params?: any) {
  return request<PaymentPlatform[]>({
    uri: '/api/business/member/pay/listPlatform',
    params,
    method: 'GET',
  })
}

/**
 * 支付订单详情
 * @param params
 * @returns
 */
export function orderDetail(params?: { orderNo: string }) {
  return request<Record<string, any>>({
    uri: '/api/business/member/order/getDb',
    params,
    method: 'POST',
  })
}

// 支付
export function pay(params?: any) {
  return request({
    uri: '/api/business/member/pay/pay',
    params,
    method: 'POST',
    options: {
      isShowMessage: false,
    },
  })
}

// 礼宾车订单支付详情
export type CarOrderPayWay = {
  value: string
  payType: string
  type: 'weixin' | 'alipay' | string
  logo: string
}

export type CarOrderPayDetail = {
  orderCode: string
  person: string
  personPhone: string
  serviceTypeNewStr: string
  carLevel: string
  flightName: string
  flightFT: string
  departureTime: string
  fallTime: string
  serviceTime: string
  cusPrice: number
  payWayList: CarOrderPayWay[]
}

export function getCarOrder(params: {
  lg: string
  orderCode: string
  sensitive: boolean
}) {
  return request<CarOrderPayDetail>({
    uri: '/api/business/member/boss/order/getCarOrder',
    params,
    method: 'POST',
  })
}

export function bossOrderToPay(params: {
  orderNo: string
  payType: string
  url: string
  title: string
}) {
  return request<{
    url: string
    orderNo: string
    payStatus?: number
    data?: Record<string, any>
  }>({
    uri: '/api/business/member/boss/order/toPay',
    params,
    method: 'POST',
  })
}

// 查询订单可用优惠券
export function orderCouponList(params: {
  proCode: string // 商品code
  productNum: string // 商品数量
  skuId: number // 品类类型
  url?: string
}) {
  const { url, ...ellsParams } = params
  return request({
    uri: `/api/business${
      url ? decodeURIComponent(url) : '/product/coupon/orderCouponList'
    }`,
    params: ellsParams,
    method: 'POST',
  })
}

// 查询订单可用权益
export function usableEquityList(params: {
  proCode: string // 商品code
  proNum: string // 商品数量
  categoryType: string // 品类类型
  skuCode?: string
  serviceTime?: string
}) {
  return request({
    uri: `/api/business/product/equity/getEquityList`,
    params,
    method: 'GET',
  })
}

// 获取个人中心设置
export function tenantStyles(params: { types: string[] }) {
  return request({
    uri: '/api/business/member/tenant/styles',
    params,
    method: 'POST',
  })
}

// 积分明细 http://192.168.1.98:3000/project/2051/interface/api/96905
export function memberPoint(params: { year: string }) {
  return request({
    uri: '/api/business/member/member/point',
    params,
    method: 'POST',
  })
}

// 获取可用的商品列表
type ProductProductListParams =
  | {
      couponMemberId: string | number
      couponTemplateId?: string | number
    }
  | {
      couponMemberId?: string | number
      couponTemplateId: string | number
    }

export function productProductList(params: ProductProductListParams) {
  return request({
    uri: '/api/business/member/product/productList',
    params,
    method: 'POST',
  })
}

// 计算价格
export function getCost(params: any) {
  return request({
    uri: '/api/business/appointment/order/cost',
    params,
    method: 'POST',
  })
}

// 授权
export function triggerNodeOauth(params: {
  triggerNodeCode: string
  triggerNode: string
  smsCode?: string
  mobile?: string
  userName?: string
}) {
  return request({
    uri: '/api/business/member/tenant/auth/authorize',
    params,
    method: 'POST',
  })
}

/**
 * 授权-核销类
 * @param params
 * @returns
 */
export function triggerNodeOauthVerif(params: {
  triggerNodeCode: string
  triggerNode: string
  smsCode?: string
  mobile?: string
  userName?: string
}) {
  return request({
    uri: '/api/business/coupon/tenant/auth/authorize',
    params,
    method: 'POST',
  })
}

export function checkPageOauth(params: {
  triggerNodeCode: string
  triggerNode: string
}) {
  return request<{
    needAuthorize: boolean
  }>({
    uri: '/api/business/member/tenant/auth/check',
    params,
    method: 'POST',
  })
}

// 用户信息
// @url http://192.168.1.98:3000/project/2051/interface/api/93079
export function getMemberInfo(params?: Record<string, any>) {
  return request<{
    levelId: string | null
    needBind: string | null
    userCode: string
    userName: string | null
    mobile: string
    guestCode: string | null
    id: null | string
  }>({
    uri: '/api/business/member/member/info',
    params: params ?? {},
    method: 'GET',
  })
}

// 用户信息 可脱敏或不可脱敏
export function getMemberInfoWithDesensitization() {
  return request<{
    userName: string | null
    email: string | null
    mobile: string
    guestCode: string | null
  }>({
    uri: '/api/business/member/tenant/auth/info',
    params: {},
    method: 'POST',
  })
}

// 用户信息
// @url http://192.168.1.98:3000/project/2051/interface/api/93079
export function getMemberInfoVerif(params?: Record<string, any>) {
  return request<{
    levelId: string | null
    needBind: string | null
    userCode: string
    userName: string | null
    mobile: string
    guestCode: string | null
    id: null | string
  }>({
    uri: '/api/business/coupon/tenant/auth/info',
    params: params ?? {},
    method: 'GET',
  })
}

/**
 * 权益激活
 * @returns
 */
export function equityActivate(params: { equityCouponCode: string }) {
  return request({
    uri: '/api/business/product/equity/activate',
    method: 'POST',
    params,
  })
}

/**
 * 获取订单是否可支付
 * @returns
 */
export function checkOrderPay(params: { orderNo: string }) {
  return request({
    uri: '/api/business/member/order/checkOrderPay',
    method: 'POST',
    params,
  })
}

// 国际支付
export function createPayIntl(params: any) {
  return new Promise((resolve, reject) => {
    fetch(`${intlUrl}/payment/v2/front/cacheCardInfo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        caller: 'saas',
      },
      body: JSON.stringify({
        ...params,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.state === '1') {
          resolve(res.result as { token: string })
        } else {
          reject(res.msg)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function payIntl(params: {
  orderNo: string
  token: string
  redirectUrl: string
  configId: string
  deviceInfo: {
    [key: string]: number | string
  }
}) {
  return request<{
    isFinish: boolean
    payUrl: string
  }>({
    uri: '/api/business/member/pay/overseas/pay',
    method: 'POST',
    params,
    options: {
      hasLoading: false,
    },
  })
}

// 检查用户是否已登录
export function checkUserLogin() {
  return request({
    uri: '/api/business/member/tenant/loginStatus/check',
    method: 'POST',
    // options: {
    //   isShowMessage: false,
    // },
  })
}

// 获取手机区号
export function getTelAreaCodes() {
  return request<MobileAreaDataTypes>({
    uri: '/api/business/member/address/telAreaCodes',
    method: 'GET',
  })
}

/**
 * 获取租户设置
 * @param params
 * @returns
 */
export function getTenantLangSetting(params: { tenantCode: string }) {
  return request<{
    enableEventTracking: boolean
    [key: string]: any
  }>({
    uri: '/api/business/member/tenant/setting',
    params,
    method: 'GET',
    options: {
      hasLoading: false,
    },
  })
}
